export default __webpack_public_path__ + "static/media/27.d7fb2007.png";